import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button'; // Assuming you have a custom Button component

const EasyPayCard = ({ paymentLink ,isArabic }) => {
  const [loading, setLoading] = useState(false); // State to handle loading state
  const [error, setError] = useState(null); // State to handle errors
  const [clicked, setClicked] = useState(false); // State to track if the button has been clicked
  const [timerExpired, setTimerExpired] = useState(false); // State for timer expiry
console.log('Hello',isArabic)
  // Generate a unique key for the payment link
  const storageKey = `easyPayCardClicked-${paymentLink}`;

  // Load clicked state from localStorage on component mount
  useEffect(() => {
    const savedClickedState = localStorage.getItem(storageKey) === 'true';
    setClicked(savedClickedState);

    // Set up the timer to disable the button after 3 minutes
    const timer = setTimeout(() => {
      setTimerExpired(true); // Disable the button when the timer expires
    }, 180000); // 180,000 milliseconds = 3 minutes

    // Cleanup the timer when the component unmounts
    return () => clearTimeout(timer);
  }, [storageKey]);

  const handlePayNow = () => {
    setLoading(true);
    setError(null);

    // Update React state to disable the button
    setClicked(true);

    // Save the clicked state to localStorage
    localStorage.setItem(storageKey, 'true');

    try {
      if (paymentLink) {
        window.open(paymentLink, '_blank'); // Open the payment link in a new tab
      } else {
        setError('Payment link is not available.');
      }
    } catch (err) {
      setError(`Error: ${err.message || 'An unexpected error occurred.'}`);
    } finally {
      setLoading(false);
    }
  };

  const buttonStyle = {
    display: 'block',
    backgroundColor: clicked || timerExpired ? '#81A57C' : '#007560', // Change button color to grey if clicked or timer expired
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: clicked || timerExpired ? 'not-allowed' : 'pointer', // Change cursor style if clicked or timer expired
    fontSize: '16px',
  };

  return (
    <div >
      {error && <p style={{ color: 'red' }}>{error}</p>}
      <Button
        style={buttonStyle}
        onClick={handlePayNow}
        disabled={loading || clicked || timerExpired} // Disable the button if loading, clicked, or timer expired
      >
        {isArabic ? 'ادفع الآن' : 'Pay Now'}
      </Button>
    </div>
  );
};

export default EasyPayCard;
